/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export const erase = (array, value, isEqual) =>
{
  const index = isEqual ? array.findIndex(rhs => isEqual(value, rhs)) : array.indexOf(value);

  if (index !== -1)
  {
    array.splice(index, 1);
  }
}


export const unique = (array, isEqual) =>
{
  const uniqueOnlyCallback = (lhs, index, array) =>
  {
    const found = isEqual ? array.findIndex(rhs => isEqual(lhs, rhs)) : array.indexOf(lhs);

    return found === index;
  }

  return array.filter(uniqueOnlyCallback);
}


export const findBest = (array, isBetter) =>
{
  let found = null;

  for (const item of array)
  {
    if (found === null || isBetter(item, found))
    {
      found = item;
    }
  }

  return found;
}


export const findMax = (array, getValue) =>
{
  return findBest(array, (lhs, rhs) => getValue(lhs) > getValue(rhs));
}


export const findMin = (array, getValue) =>
{
  return findBest(array, (lhs, rhs) => getValue(lhs) < getValue(rhs));
}


export const sum = (array, getValue) =>
{
  return array.reduce((total, element) => total + getValue(element), 0);
}


export const indexOfByValue = (array, value) =>
{
  for (let i = 0; i < array.length; i++)
  {
    if (array[i].valueOf() === value.valueOf())
    {
      return i;
    }
  }

  return - 1;
}


export const getLowerBound = (collection, id) =>
{
  let lo = 0;
  let hi = collection.length;

  while (lo < hi)
  {
    const mid = (lo + hi) >> 1;

    if (collection[mid].id < id)
    {
      lo = mid + 1;
    }
    else
    {
      hi = mid;
    }
  }

  return lo;
}
